import { render, staticRenderFns } from "./SimulaApuracao.vue?vue&type=template&id=e31f5464&"
import script from "./SimulaApuracao.vue?vue&type=script&lang=js&"
export * from "./SimulaApuracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports